'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$26() {
  this.ayI = null;
  this.ayJ = false;
}
export { $c_Lpresto_AgentView$$anon$26 as $c_Lpresto_AgentView$$anon$26 };
$p = $c_Lpresto_AgentView$$anon$26.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$26;
/** @constructor */
function $h_Lpresto_AgentView$$anon$26() {
}
export { $h_Lpresto_AgentView$$anon$26 as $h_Lpresto_AgentView$$anon$26 };
$h_Lpresto_AgentView$$anon$26.prototype = $p;
$p.P = (function() {
  if ((!this.ayJ)) {
    this.ayI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.ayJ = true;
  }
  return this.ayI;
});
var $d_Lpresto_AgentView$$anon$26 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$26, "presto.AgentView$$anon$26", ({
  DV: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$26 as $d_Lpresto_AgentView$$anon$26 };
//# sourceMappingURL=presto.-Agent-View$$anon$26.js.map
